// @flow
import React, { Component, lazy, Suspense } from "react";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Grid from "@material-ui/core/Grid";

import { LoadingProgress } from "imagus-components";
const BillingItem = lazy((): * => import("./BillingAdminItem"));

type BillingListStatesType = {
  expanded: string | boolean
};

type BillingListPropsType = {
  companies: Array<{ [key: string]: * }>,
  setActionError: Function,
  openSnackbar: Function
};

class BillingList extends Component<
  BillingListPropsType,
  BillingListStatesType
> {
  constructor(props: BillingListPropsType) {
    super(props);
    this.state = {
      expanded: false
    };
  }

  handleChange = (panel: string): * => (event: Event, expanded: boolean) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  render(): * {
    const { expanded } = this.state;
    const companies = this.props.companies;
    let list = [];
    companies.map(
      (company: *, i: number): * => {
        list.push(
          <ExpansionPanel
            expanded={expanded === company.id}
            onChange={this.handleChange(company.id)}
            key={i}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1" className="heading">
                <b>Company Name</b>{" "}
                {company.name}
              </Typography>
              <Typography variant="subtitle1" className="subheading">
                <b>Company Uuid</b>{" "}
                {company.uuid}
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Suspense fallback={<LoadingProgress />}>
                <BillingItem
                  companyId={company.id}
                  setActionError={this.props.setActionError}
                  openSnackbar={this.props.openSnackbar}
                  expanded={expanded === company.id}
                />
              </Suspense>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        );
      }
    );

    return (
      <div className="app-panel-content panel-top-margin">
        <Grid container spacing={24}>
          <Grid item xs={12}>
            {list}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default BillingList;
